import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
import './Footer.css';

const getCurrentYear = () => new Date().getFullYear();

const Footer = () => {
  const stats = [
    {
      value: "Vzdialená pomoc",
      href: "https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/XESTMJSAG21O/AnyDeskInverPreklientov.exe",
      rel: "noopener noreferrer",
    },
    {
      value: "Vstup do podpory",
      href: "/podpora",
      rel: "noopener noreferrer",
    },
    {
      value: `Webmail`,
      href: "https://webmail.inver.sk",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      value: "Zmena hesla",
      href: "https://m.inver.sk/pwchange",
      target: "_blank",
      rel: "noopener noreferrer",
    },
  ];

  return (
    <footer id="contact-footer" className="modern-footer">
      <div className="footer-container">
        
        {/* Horná časť - Logo a opis */}
        <div className="footer-top">
          <div className="footer-logo">
            <img src="/logo_inv.png" alt="INVER s.r.o." className="footer-logo-image" />
          </div>
          <p className="company-description">
            Moderné IT riešenia pre váš biznis. Špecializujeme sa na komplexné informačné systémy, 
            webhosting a kybernetickú bezpečnosť s viac ako {getCurrentYear() - 1989}-ročnou tradíciou.
          </p>
        </div>

        {/* Dolná časť - Kontakt */}
        <div className="footer-contact">
          {/* Additional Links */}
          <div className="footer-links">
            {stats.map((stat, index) => (
              <div key={index} className="footer-link-item">
                <a href={stat.href} target={stat.target || "_self"} rel={stat.rel}>
                  {stat.value}
                </a>
              </div>
            ))}
          </div>
          
          <div className="contact-grid">
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div className="contact-text">
                <a 
                  href="https://maps.app.goo.gl/kGSFi2S5vX8Gie558" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Hutnícka 1 (4. poschodie), 040 01 Košice
                </a>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="contact-text">
                <a href="tel:+421557999111">055/7999111</a>
              </div>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-text">
                <a href="mailto:inver@inver.sk">inver@inver.sk</a>
              </div>
            </div>
            <div className="contact-item">
              <FaClock className="contact-icon" />
              <div className="contact-text">
                <span>Po-Pi: 8:00-17:00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Spodná časť - len copyright */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {getCurrentYear()} INVER s.r.o. Všetky práva vyhradené. | Vyvinula INVER s.r.o.</p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;